import React from 'react';
import { motion } from 'framer-motion';
export function SignalSection() {
  return <section className="bg-gradient-section py-24 md:py-32 px-5 md:px-8" data-id="element-207">
      <div className="max-w-2xl mx-auto text-center" data-id="element-208">
        <motion.p initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="uppercase tracking-[0.3em] text-[#C8A870] font-semibold mb-7 text-[13px]" data-id="element-209">
          Tu cuerpo no falló
        </motion.p>

        <motion.h2 initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="font-display font-semibold text-[#F0E8D8] leading-[1.12]" data-id="element-210">
          <span className="block text-[34px] md:text-5xl" data-id="element-211">
            Cambió la señal.
          </span>
          <span className="block italic text-gradient-gold text-[32px] md:text-5xl mt-2" data-id="element-212">
            Y eso cambia lo que necesitás hoy.
          </span>
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        delay: 0.1
      }} className="mt-8 font-body md:text-[18px] text-foreground/65 max-w-lg mx-auto font-[400] text-[18px]" data-id="element-213">
          Entre los 35 y los 55 años, las hormonas cambian. Por eso lo que antes
          te funcionaba puede dejar de dar los mismos resultados. H.E.R. fue
          diseñado para acompañar esta transición de forma simple y sostenible.
        </motion.p>

        <div className="divider-fine w-24 mx-auto mt-14" data-id="element-214" />
      </div>
    </section>;
}